import React from 'react'

import {Button, Modal, Table} from 'antd'
const {Column} = Table

import {TokensStorage} from 'storage/Token.jsx'
import {TokenService} from 'api/tokens'
import {AuthStore} from 'api/auth'

const hasExpired = ({expires}) => new Date().toISOString() >= expires
const isRevoked = token => !!token.revoked

const Expirey = ({record}) => {
   if (isRevoked(record)) {
      return <span>Revoked: {record.revoked.reason}</span>
   } else if (hasExpired(record)) {
      return <span>Expired {record.expires}</span>
   }

   return null
}

Expirey.propTypes = {
   record: React.PropTypes.object
}

export class TokenTable extends React.Component {
   render() {
      const {tokens, loading} = this.props

      return (
         <div>
            <Table className="values" dataSource={tokens} loading={loading}>
               <Column
                  title="Fingerprint"
                  dataIndex="fingerprint"
                  key="fingerprint"
                  render={(text, _record) => text.substr(0, 9)}
               />
               <Column title="Name" dataIndex="name" key="name" />
               <Column title="Type" dataIndex="type" key="type" />

               <Column title="Created" dataIndex="meta.created" key="meta.created" />
               <Column title="Last Used" dataIndex="meta.used" key="meta.used" />
               <Column
                  title="Expiry"
                  key="meta.expirey"
                  render={(text, record) => <Expirey record={record} />}
               />
               <Column
                  title="Actions"
                  key="actions"
                  render={(text, record) => <Actions record={record} />}
               />
            </Table>
         </div>
      )
   }
}

TokenTable.propTypes = {
   tokens:      React.PropTypes.array.isRequired,
   loading:     React.PropTypes.bool,
   addNewToken: React.PropTypes.bool
}

class Actions extends React.Component {
   static get propTypes() {
      return {
         record: React.PropTypes.object
      }
   }

   constructor() {
      super()

      this.state = {
         loading: false
      }

      this.handleRevoke = this.handleRevoke.bind(this)
   }

   handleRevoke() {
      const {record} = this.props

      if (record.fingerprint === AuthStore.auth.fingerprint) {
         Modal.warning({
            title:   'Can\'t revoke own token',
            content: 'You are trying to your revoke your own access token. Sign out instead'
         })

         return
      }

      this.setState({loading: true})
      TokenService.revoke(this.props.record.fingerprint, 'workbench').done(() =>
         this.setState({loading: true}),
      )
   }

   render() {
      let {record} = this.props

      if (isRevoked(record)) {
         return <span>Revoked {record.revoked.at}</span>
      } else if (hasExpired(record)) {
         return null
      } else {
         return (
            <span>
               <Button type="danger" loading={this.state.loading} onClick={this.handleRevoke}>
                  Revoke
               </Button>
            </span>
         )
      }
   }
}

export class Tokens extends React.Component {
   render() {
      const props = this.props

      return (
         <div className="userauth tokens">
            <div className="page-header">
               <h1>API Tokens</h1>
            </div>

            <TokensStorage {...props}>
               <TokenTable tokens={[]} />
            </TokensStorage>
         </div>
      )
   }
}



// WEBPACK FOOTER //
// lib/bundle/user/Tokens.jsx